import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps';

export default {
    getPositionsMachines: {
        apiServiceMethodName: ModulesConfigMap[ModulesMap.POSITIONS_MACHINES].GET_POSITIONS_MACHINES
    },
    
    getPositionsMachine: {
        apiServiceMethodName: ModulesConfigMap[ModulesMap.POSITIONS_MACHINES].GET_POSITIONS_MACHINE
    },

    getPositionsMachineOnTimePoint: {
        apiServiceMethodName: ModulesConfigMap[ModulesMap.POSITIONS_MACHINES].GET_POSITIONS_ON_TIME_POINT
    }

}